const DATA_ATTR = "data-nh-scroll-lock-count";

let lockCount = 0;
let savedScrollY = 0;
let savedBodyStyles = null;
let savedHtmlOverflow = "";

function getScrollbarWidth() {
  if (typeof window === "undefined") return 0;
  return Math.max(0, window.innerWidth - document.documentElement.clientWidth);
}

function applyLock() {
  if (typeof document === "undefined") return;

  savedScrollY = window.scrollY || window.pageYOffset || 0;
  const body = document.body;
  const html = document.documentElement;

  savedBodyStyles = {
    overflow: body.style.overflow,
    position: body.style.position,
    top: body.style.top,
    left: body.style.left,
    right: body.style.right,
    width: body.style.width,
    paddingRight: body.style.paddingRight,
  };
  savedHtmlOverflow = html.style.overflow;

  const scrollbarWidth = getScrollbarWidth();

  html.style.overflow = "hidden";
  body.style.overflow = "hidden";
  body.style.position = "fixed";
  body.style.top = `-${savedScrollY}px`;
  body.style.left = "0";
  body.style.right = "0";
  body.style.width = "100%";

  if (scrollbarWidth > 0) {
    body.style.paddingRight = `${scrollbarWidth}px`;
  }

  body.setAttribute(DATA_ATTR, String(lockCount));
}

function releaseLock() {
  if (typeof document === "undefined" || !savedBodyStyles) return;

  const body = document.body;
  const html = document.documentElement;
  const scrollY = savedScrollY;

  body.style.overflow = savedBodyStyles.overflow;
  body.style.position = savedBodyStyles.position;
  body.style.top = savedBodyStyles.top;
  body.style.left = savedBodyStyles.left;
  body.style.right = savedBodyStyles.right;
  body.style.width = savedBodyStyles.width;
  body.style.paddingRight = savedBodyStyles.paddingRight;
  html.style.overflow = savedHtmlOverflow;

  savedBodyStyles = null;
  body.removeAttribute(DATA_ATTR);

  window.scrollTo(0, scrollY);
}

/** Increment scroll lock (safe for nested modals/drawers). */
export function lockBodyScroll() {
  if (typeof document === "undefined") return () => {};

  lockCount += 1;
  if (lockCount === 1) {
    applyLock();
  } else {
    document.body.setAttribute(DATA_ATTR, String(lockCount));
  }

  let released = false;
  return () => {
    if (released || typeof document === "undefined") return;
    released = true;

    lockCount = Math.max(0, lockCount - 1);
    if (lockCount === 0) {
      releaseLock();
    } else {
      document.body.setAttribute(DATA_ATTR, String(lockCount));
    }
  };
}

/** @returns {boolean} Whether the page background is currently scroll-locked. */
export function isBodyScrollLocked() {
  return lockCount > 0;
}
